import * as React from 'react';
import {YMaps, Map, Clusterer, Placemark} from 'react-yandex-maps';
import {initialYandexZoomValue, Props} from './model';
import MapMarker from '../../../assets/icons/map-marker.svg';

export default (props: Props) => {
  const {markers, onClickMarker, initialZoom = initialYandexZoomValue, centerPoint = markers[0].coordinates} = props;
  const mapInstance = React.useRef<any>(null);
  const handleMapInstanceChange = React.useCallback((instance) => {
    mapInstance.current = instance;
  }, []);

  React.useEffect(() => {
    if (mapInstance.current) {
      mapInstance.current.panTo(props.centerPoint);
    }
  }, [props.centerPoint, mapInstance.current]);

  return (
    <YMaps>
      <Map
        instanceRef={handleMapInstanceChange}
        options={{autoFitToViewport: 'always'}}
        height={'100%'}
        width={'100%'}
        style={{width: '100%', height: '100%'}}
        defaultState={{center: centerPoint, zoom: initialZoom}}>
        <Clusterer options={{preset: 'islands#invertedDarkBlueClusterIcons'}}>
          {markers.map((marker, index) => (
            <Placemark
              options={{
                iconLayout: 'default#image',
                iconImageHref: MapMarker,
                iconImageSize: [60, 60],
                iconImageOffset: [-30, -60],
              }}
              onClick={() => onClickMarker(marker)}
              key={index}
              geometry={marker.coordinates}
            />
          ))}
        </Clusterer>
      </Map>
    </YMaps>
  );
};
